/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Platform = $root.Platform = (() => {

    /**
     * Namespace Platform.
     * @exports Platform
     * @namespace
     */
    const Platform = {};

    Platform.Service = (function() {

        /**
         * Namespace Service.
         * @memberof Platform
         * @namespace
         */
        const Service = {};

        Service.Map = (function() {

            /**
             * Namespace Map.
             * @memberof Platform.Service
             * @namespace
             */
            const Map = {};

            Map.Feature = (function() {

                /**
                 * Properties of a Feature.
                 * @memberof Platform.Service.Map
                 * @interface IFeature
                 * @property {number|null} [id] Feature id
                 * @property {google.protobuf.ITimestamp|null} [createdAt] Feature createdAt
                 * @property {google.protobuf.ITimestamp|null} [updatedAt] Feature updatedAt
                 * @property {string|null} [createdBy] Feature createdBy
                 * @property {string|null} [updatedBy] Feature updatedBy
                 * @property {StoneCode.PlatformBundle.Common.Entity.IUrn|null} [map] Feature map
                 * @property {StoneCode.PlatformBundle.Common.Entity.IUrn|null} [featureType] Feature featureType
                 * @property {google.protobuf.IStruct|null} [coordinates] Feature coordinates
                 * @property {google.protobuf.IStruct|null} [extra] Feature extra
                 * @property {string|null} [entityUrn] Feature entityUrn
                 * @property {string|null} [layer] Feature layer
                 * @property {number|Long|null} [lastModified] Feature lastModified
                 */

                /**
                 * Constructs a new Feature.
                 * @memberof Platform.Service.Map
                 * @classdesc Represents a Feature.
                 * @implements IFeature
                 * @constructor
                 * @param {Platform.Service.Map.IFeature=} [properties] Properties to set
                 */
                function Feature(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Feature id.
                 * @member {number} id
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.id = 0;

                /**
                 * Feature createdAt.
                 * @member {google.protobuf.ITimestamp|null|undefined} createdAt
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.createdAt = null;

                /**
                 * Feature updatedAt.
                 * @member {google.protobuf.ITimestamp|null|undefined} updatedAt
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.updatedAt = null;

                /**
                 * Feature createdBy.
                 * @member {string} createdBy
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.createdBy = "";

                /**
                 * Feature updatedBy.
                 * @member {string} updatedBy
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.updatedBy = "";

                /**
                 * Feature map.
                 * @member {StoneCode.PlatformBundle.Common.Entity.IUrn|null|undefined} map
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.map = null;

                /**
                 * Feature featureType.
                 * @member {StoneCode.PlatformBundle.Common.Entity.IUrn|null|undefined} featureType
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.featureType = null;

                /**
                 * Feature coordinates.
                 * @member {google.protobuf.IStruct|null|undefined} coordinates
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.coordinates = null;

                /**
                 * Feature extra.
                 * @member {google.protobuf.IStruct|null|undefined} extra
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.extra = null;

                /**
                 * Feature entityUrn.
                 * @member {string} entityUrn
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.entityUrn = "";

                /**
                 * Feature layer.
                 * @member {string} layer
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.layer = "";

                /**
                 * Feature lastModified.
                 * @member {number|Long} lastModified
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 */
                Feature.prototype.lastModified = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                /**
                 * Creates a new Feature instance using the specified properties.
                 * @function create
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Platform.Service.Map.IFeature=} [properties] Properties to set
                 * @returns {Platform.Service.Map.Feature} Feature instance
                 */
                Feature.create = function create(properties) {
                    return new Feature(properties);
                };

                /**
                 * Encodes the specified Feature message. Does not implicitly {@link Platform.Service.Map.Feature.verify|verify} messages.
                 * @function encode
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Platform.Service.Map.IFeature} message Feature message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Feature.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                        $root.google.protobuf.Timestamp.encode(message.updatedAt, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.createdBy);
                    if (message.updatedBy != null && Object.hasOwnProperty.call(message, "updatedBy"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.updatedBy);
                    if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                        $root.StoneCode.PlatformBundle.Common.Entity.Urn.encode(message.map, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.featureType != null && Object.hasOwnProperty.call(message, "featureType"))
                        $root.StoneCode.PlatformBundle.Common.Entity.Urn.encode(message.featureType, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.coordinates != null && Object.hasOwnProperty.call(message, "coordinates"))
                        $root.google.protobuf.Struct.encode(message.coordinates, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.extra != null && Object.hasOwnProperty.call(message, "extra"))
                        $root.google.protobuf.Struct.encode(message.extra, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.entityUrn != null && Object.hasOwnProperty.call(message, "entityUrn"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.entityUrn);
                    if (message.layer != null && Object.hasOwnProperty.call(message, "layer"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.layer);
                    if (message.lastModified != null && Object.hasOwnProperty.call(message, "lastModified"))
                        writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.lastModified);
                    return writer;
                };

                /**
                 * Encodes the specified Feature message, length delimited. Does not implicitly {@link Platform.Service.Map.Feature.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Platform.Service.Map.IFeature} message Feature message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Feature.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Feature message from the specified reader or buffer.
                 * @function decode
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Platform.Service.Map.Feature} Feature
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Feature.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Platform.Service.Map.Feature();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.uint32();
                            break;
                        case 2:
                            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.updatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.createdBy = reader.string();
                            break;
                        case 5:
                            message.updatedBy = reader.string();
                            break;
                        case 6:
                            message.map = $root.StoneCode.PlatformBundle.Common.Entity.Urn.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.featureType = $root.StoneCode.PlatformBundle.Common.Entity.Urn.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.coordinates = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.extra = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.entityUrn = reader.string();
                            break;
                        case 11:
                            message.layer = reader.string();
                            break;
                        case 12:
                            message.lastModified = reader.uint64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Feature message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Platform.Service.Map.Feature} Feature
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Feature.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Feature message.
                 * @function verify
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Feature.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id))
                            return "id: integer expected";
                    if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
                        if (error)
                            return "createdAt." + error;
                    }
                    if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.updatedAt);
                        if (error)
                            return "updatedAt." + error;
                    }
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        if (!$util.isString(message.createdBy))
                            return "createdBy: string expected";
                    if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                        if (!$util.isString(message.updatedBy))
                            return "updatedBy: string expected";
                    if (message.map != null && message.hasOwnProperty("map")) {
                        let error = $root.StoneCode.PlatformBundle.Common.Entity.Urn.verify(message.map);
                        if (error)
                            return "map." + error;
                    }
                    if (message.featureType != null && message.hasOwnProperty("featureType")) {
                        let error = $root.StoneCode.PlatformBundle.Common.Entity.Urn.verify(message.featureType);
                        if (error)
                            return "featureType." + error;
                    }
                    if (message.coordinates != null && message.hasOwnProperty("coordinates")) {
                        let error = $root.google.protobuf.Struct.verify(message.coordinates);
                        if (error)
                            return "coordinates." + error;
                    }
                    if (message.extra != null && message.hasOwnProperty("extra")) {
                        let error = $root.google.protobuf.Struct.verify(message.extra);
                        if (error)
                            return "extra." + error;
                    }
                    if (message.entityUrn != null && message.hasOwnProperty("entityUrn"))
                        if (!$util.isString(message.entityUrn))
                            return "entityUrn: string expected";
                    if (message.layer != null && message.hasOwnProperty("layer"))
                        if (!$util.isString(message.layer))
                            return "layer: string expected";
                    if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                        if (!$util.isInteger(message.lastModified) && !(message.lastModified && $util.isInteger(message.lastModified.low) && $util.isInteger(message.lastModified.high)))
                            return "lastModified: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a Feature message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Platform.Service.Map.Feature} Feature
                 */
                Feature.fromObject = function fromObject(object) {
                    if (object instanceof $root.Platform.Service.Map.Feature)
                        return object;
                    let message = new $root.Platform.Service.Map.Feature();
                    if (object.id != null)
                        message.id = object.id >>> 0;
                    if (object.createdAt != null) {
                        if (typeof object.createdAt !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.createdAt: object expected");
                        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
                    }
                    if (object.updatedAt != null) {
                        if (typeof object.updatedAt !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.updatedAt: object expected");
                        message.updatedAt = $root.google.protobuf.Timestamp.fromObject(object.updatedAt);
                    }
                    if (object.createdBy != null)
                        message.createdBy = String(object.createdBy);
                    if (object.updatedBy != null)
                        message.updatedBy = String(object.updatedBy);
                    if (object.map != null) {
                        if (typeof object.map !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.map: object expected");
                        message.map = $root.StoneCode.PlatformBundle.Common.Entity.Urn.fromObject(object.map);
                    }
                    if (object.featureType != null) {
                        if (typeof object.featureType !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.featureType: object expected");
                        message.featureType = $root.StoneCode.PlatformBundle.Common.Entity.Urn.fromObject(object.featureType);
                    }
                    if (object.coordinates != null) {
                        if (typeof object.coordinates !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.coordinates: object expected");
                        message.coordinates = $root.google.protobuf.Struct.fromObject(object.coordinates);
                    }
                    if (object.extra != null) {
                        if (typeof object.extra !== "object")
                            throw TypeError(".Platform.Service.Map.Feature.extra: object expected");
                        message.extra = $root.google.protobuf.Struct.fromObject(object.extra);
                    }
                    if (object.entityUrn != null)
                        message.entityUrn = String(object.entityUrn);
                    if (object.layer != null)
                        message.layer = String(object.layer);
                    if (object.lastModified != null)
                        if ($util.Long)
                            (message.lastModified = $util.Long.fromValue(object.lastModified)).unsigned = true;
                        else if (typeof object.lastModified === "string")
                            message.lastModified = parseInt(object.lastModified, 10);
                        else if (typeof object.lastModified === "number")
                            message.lastModified = object.lastModified;
                        else if (typeof object.lastModified === "object")
                            message.lastModified = new $util.LongBits(object.lastModified.low >>> 0, object.lastModified.high >>> 0).toNumber(true);
                    return message;
                };

                /**
                 * Creates a plain object from a Feature message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Platform.Service.Map.Feature
                 * @static
                 * @param {Platform.Service.Map.Feature} message Feature
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Feature.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = 0;
                        object.createdAt = null;
                        object.updatedAt = null;
                        object.createdBy = "";
                        object.updatedBy = "";
                        object.map = null;
                        object.featureType = null;
                        object.coordinates = null;
                        object.extra = null;
                        object.entityUrn = "";
                        object.layer = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, true);
                            object.lastModified = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastModified = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
                    if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                        object.updatedAt = $root.google.protobuf.Timestamp.toObject(message.updatedAt, options);
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        object.createdBy = message.createdBy;
                    if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                        object.updatedBy = message.updatedBy;
                    if (message.map != null && message.hasOwnProperty("map"))
                        object.map = $root.StoneCode.PlatformBundle.Common.Entity.Urn.toObject(message.map, options);
                    if (message.featureType != null && message.hasOwnProperty("featureType"))
                        object.featureType = $root.StoneCode.PlatformBundle.Common.Entity.Urn.toObject(message.featureType, options);
                    if (message.coordinates != null && message.hasOwnProperty("coordinates"))
                        object.coordinates = $root.google.protobuf.Struct.toObject(message.coordinates, options);
                    if (message.extra != null && message.hasOwnProperty("extra"))
                        object.extra = $root.google.protobuf.Struct.toObject(message.extra, options);
                    if (message.entityUrn != null && message.hasOwnProperty("entityUrn"))
                        object.entityUrn = message.entityUrn;
                    if (message.layer != null && message.hasOwnProperty("layer"))
                        object.layer = message.layer;
                    if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                        if (typeof message.lastModified === "number")
                            object.lastModified = options.longs === String ? String(message.lastModified) : message.lastModified;
                        else
                            object.lastModified = options.longs === String ? $util.Long.prototype.toString.call(message.lastModified) : options.longs === Number ? new $util.LongBits(message.lastModified.low >>> 0, message.lastModified.high >>> 0).toNumber(true) : message.lastModified;
                    return object;
                };

                /**
                 * Converts this Feature to JSON.
                 * @function toJSON
                 * @memberof Platform.Service.Map.Feature
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Feature.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Feature;
            })();

            Map.Map = (function() {

                /**
                 * Properties of a Map.
                 * @memberof Platform.Service.Map
                 * @interface IMap
                 * @property {number|null} [id] Map id
                 * @property {google.protobuf.ITimestamp|null} [createdAt] Map createdAt
                 * @property {google.protobuf.ITimestamp|null} [updatedAt] Map updatedAt
                 * @property {string|null} [createdBy] Map createdBy
                 * @property {string|null} [updatedBy] Map updatedBy
                 * @property {StoneCode.PlatformBundle.Common.Entity.IUrn|null} [project] Map project
                 * @property {google.protobuf.IStruct|null} [configuration] Map configuration
                 * @property {string|null} [label] Map label
                 * @property {string|null} [slug] Map slug
                 */

                /**
                 * Constructs a new Map.
                 * @memberof Platform.Service.Map
                 * @classdesc Represents a Map.
                 * @implements IMap
                 * @constructor
                 * @param {Platform.Service.Map.IMap=} [properties] Properties to set
                 */
                function Map(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Map id.
                 * @member {number} id
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.id = 0;

                /**
                 * Map createdAt.
                 * @member {google.protobuf.ITimestamp|null|undefined} createdAt
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.createdAt = null;

                /**
                 * Map updatedAt.
                 * @member {google.protobuf.ITimestamp|null|undefined} updatedAt
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.updatedAt = null;

                /**
                 * Map createdBy.
                 * @member {string} createdBy
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.createdBy = "";

                /**
                 * Map updatedBy.
                 * @member {string} updatedBy
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.updatedBy = "";

                /**
                 * Map project.
                 * @member {StoneCode.PlatformBundle.Common.Entity.IUrn|null|undefined} project
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.project = null;

                /**
                 * Map configuration.
                 * @member {google.protobuf.IStruct|null|undefined} configuration
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.configuration = null;

                /**
                 * Map label.
                 * @member {string} label
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.label = "";

                /**
                 * Map slug.
                 * @member {string} slug
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 */
                Map.prototype.slug = "";

                /**
                 * Creates a new Map instance using the specified properties.
                 * @function create
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Platform.Service.Map.IMap=} [properties] Properties to set
                 * @returns {Platform.Service.Map.Map} Map instance
                 */
                Map.create = function create(properties) {
                    return new Map(properties);
                };

                /**
                 * Encodes the specified Map message. Does not implicitly {@link Platform.Service.Map.Map.verify|verify} messages.
                 * @function encode
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Platform.Service.Map.IMap} message Map message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Map.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        $root.google.protobuf.Timestamp.encode(message.createdAt, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                        $root.google.protobuf.Timestamp.encode(message.updatedAt, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.createdBy);
                    if (message.updatedBy != null && Object.hasOwnProperty.call(message, "updatedBy"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.updatedBy);
                    if (message.project != null && Object.hasOwnProperty.call(message, "project"))
                        $root.StoneCode.PlatformBundle.Common.Entity.Urn.encode(message.project, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.configuration != null && Object.hasOwnProperty.call(message, "configuration"))
                        $root.google.protobuf.Struct.encode(message.configuration, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.label);
                    if (message.slug != null && Object.hasOwnProperty.call(message, "slug"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.slug);
                    return writer;
                };

                /**
                 * Encodes the specified Map message, length delimited. Does not implicitly {@link Platform.Service.Map.Map.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Platform.Service.Map.IMap} message Map message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Map.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Map message from the specified reader or buffer.
                 * @function decode
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {Platform.Service.Map.Map} Map
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Map.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Platform.Service.Map.Map();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.uint32();
                            break;
                        case 2:
                            message.createdAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.updatedAt = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.createdBy = reader.string();
                            break;
                        case 5:
                            message.updatedBy = reader.string();
                            break;
                        case 6:
                            message.project = $root.StoneCode.PlatformBundle.Common.Entity.Urn.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.configuration = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.label = reader.string();
                            break;
                        case 9:
                            message.slug = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Map message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {Platform.Service.Map.Map} Map
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Map.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Map message.
                 * @function verify
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Map.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id))
                            return "id: integer expected";
                    if (message.createdAt != null && message.hasOwnProperty("createdAt")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.createdAt);
                        if (error)
                            return "createdAt." + error;
                    }
                    if (message.updatedAt != null && message.hasOwnProperty("updatedAt")) {
                        let error = $root.google.protobuf.Timestamp.verify(message.updatedAt);
                        if (error)
                            return "updatedAt." + error;
                    }
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        if (!$util.isString(message.createdBy))
                            return "createdBy: string expected";
                    if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                        if (!$util.isString(message.updatedBy))
                            return "updatedBy: string expected";
                    if (message.project != null && message.hasOwnProperty("project")) {
                        let error = $root.StoneCode.PlatformBundle.Common.Entity.Urn.verify(message.project);
                        if (error)
                            return "project." + error;
                    }
                    if (message.configuration != null && message.hasOwnProperty("configuration")) {
                        let error = $root.google.protobuf.Struct.verify(message.configuration);
                        if (error)
                            return "configuration." + error;
                    }
                    if (message.label != null && message.hasOwnProperty("label"))
                        if (!$util.isString(message.label))
                            return "label: string expected";
                    if (message.slug != null && message.hasOwnProperty("slug"))
                        if (!$util.isString(message.slug))
                            return "slug: string expected";
                    return null;
                };

                /**
                 * Creates a Map message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {Platform.Service.Map.Map} Map
                 */
                Map.fromObject = function fromObject(object) {
                    if (object instanceof $root.Platform.Service.Map.Map)
                        return object;
                    let message = new $root.Platform.Service.Map.Map();
                    if (object.id != null)
                        message.id = object.id >>> 0;
                    if (object.createdAt != null) {
                        if (typeof object.createdAt !== "object")
                            throw TypeError(".Platform.Service.Map.Map.createdAt: object expected");
                        message.createdAt = $root.google.protobuf.Timestamp.fromObject(object.createdAt);
                    }
                    if (object.updatedAt != null) {
                        if (typeof object.updatedAt !== "object")
                            throw TypeError(".Platform.Service.Map.Map.updatedAt: object expected");
                        message.updatedAt = $root.google.protobuf.Timestamp.fromObject(object.updatedAt);
                    }
                    if (object.createdBy != null)
                        message.createdBy = String(object.createdBy);
                    if (object.updatedBy != null)
                        message.updatedBy = String(object.updatedBy);
                    if (object.project != null) {
                        if (typeof object.project !== "object")
                            throw TypeError(".Platform.Service.Map.Map.project: object expected");
                        message.project = $root.StoneCode.PlatformBundle.Common.Entity.Urn.fromObject(object.project);
                    }
                    if (object.configuration != null) {
                        if (typeof object.configuration !== "object")
                            throw TypeError(".Platform.Service.Map.Map.configuration: object expected");
                        message.configuration = $root.google.protobuf.Struct.fromObject(object.configuration);
                    }
                    if (object.label != null)
                        message.label = String(object.label);
                    if (object.slug != null)
                        message.slug = String(object.slug);
                    return message;
                };

                /**
                 * Creates a plain object from a Map message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof Platform.Service.Map.Map
                 * @static
                 * @param {Platform.Service.Map.Map} message Map
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Map.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = 0;
                        object.createdAt = null;
                        object.updatedAt = null;
                        object.createdBy = "";
                        object.updatedBy = "";
                        object.project = null;
                        object.configuration = null;
                        object.label = "";
                        object.slug = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                        object.createdAt = $root.google.protobuf.Timestamp.toObject(message.createdAt, options);
                    if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                        object.updatedAt = $root.google.protobuf.Timestamp.toObject(message.updatedAt, options);
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        object.createdBy = message.createdBy;
                    if (message.updatedBy != null && message.hasOwnProperty("updatedBy"))
                        object.updatedBy = message.updatedBy;
                    if (message.project != null && message.hasOwnProperty("project"))
                        object.project = $root.StoneCode.PlatformBundle.Common.Entity.Urn.toObject(message.project, options);
                    if (message.configuration != null && message.hasOwnProperty("configuration"))
                        object.configuration = $root.google.protobuf.Struct.toObject(message.configuration, options);
                    if (message.label != null && message.hasOwnProperty("label"))
                        object.label = message.label;
                    if (message.slug != null && message.hasOwnProperty("slug"))
                        object.slug = message.slug;
                    return object;
                };

                /**
                 * Converts this Map to JSON.
                 * @function toJSON
                 * @memberof Platform.Service.Map.Map
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Map.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Map;
            })();

            return Map;
        })();

        return Service;
    })();

    return Platform;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                return writer;
            };

            /**
             * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.seconds = reader.int64();
                        break;
                    case 2:
                        message.nanos = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Timestamp message.
             * @function verify
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Timestamp.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                        return "seconds: integer|Long expected";
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    if (!$util.isInteger(message.nanos))
                        return "nanos: integer expected";
                return null;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Timestamp;
        })();

        protobuf.Struct = (function() {

            /**
             * Properties of a Struct.
             * @memberof google.protobuf
             * @interface IStruct
             * @property {Object.<string,google.protobuf.IValue>|null} [fields] Struct fields
             */

            /**
             * Constructs a new Struct.
             * @memberof google.protobuf
             * @classdesc Represents a Struct.
             * @implements IStruct
             * @constructor
             * @param {google.protobuf.IStruct=} [properties] Properties to set
             */
            function Struct(properties) {
                this.fields = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Struct fields.
             * @member {Object.<string,google.protobuf.IValue>} fields
             * @memberof google.protobuf.Struct
             * @instance
             */
            Struct.prototype.fields = $util.emptyObject;

            /**
             * Creates a new Struct instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct=} [properties] Properties to set
             * @returns {google.protobuf.Struct} Struct instance
             */
            Struct.create = function create(properties) {
                return new Struct(properties);
            };

            /**
             * Encodes the specified Struct message. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct} message Struct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Struct.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fields != null && Object.hasOwnProperty.call(message, "fields"))
                    for (let keys = Object.keys(message.fields), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.google.protobuf.Value.encode(message.fields[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified Struct message, length delimited. Does not implicitly {@link google.protobuf.Struct.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.IStruct} message Struct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Struct.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Struct message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Struct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Struct} Struct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Struct.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Struct(), key, value;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.fields === $util.emptyObject)
                            message.fields = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.google.protobuf.Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.fields[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Struct message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Struct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Struct} Struct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Struct.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Struct message.
             * @function verify
             * @memberof google.protobuf.Struct
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Struct.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fields != null && message.hasOwnProperty("fields")) {
                    if (!$util.isObject(message.fields))
                        return "fields: object expected";
                    let key = Object.keys(message.fields);
                    for (let i = 0; i < key.length; ++i) {
                        let error = $root.google.protobuf.Value.verify(message.fields[key[i]]);
                        if (error)
                            return "fields." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Struct message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Struct
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Struct} Struct
             */
            Struct.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Struct)
                    return object;
                let message = new $root.google.protobuf.Struct();
                if (object.fields) {
                    if (typeof object.fields !== "object")
                        throw TypeError(".google.protobuf.Struct.fields: object expected");
                    message.fields = {};
                    for (let keys = Object.keys(object.fields), i = 0; i < keys.length; ++i) {
                        if (typeof object.fields[keys[i]] !== "object")
                            throw TypeError(".google.protobuf.Struct.fields: object expected");
                        message.fields[keys[i]] = $root.google.protobuf.Value.fromObject(object.fields[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Struct message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Struct
             * @static
             * @param {google.protobuf.Struct} message Struct
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Struct.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.fields = {};
                let keys2;
                if (message.fields && (keys2 = Object.keys(message.fields)).length) {
                    object.fields = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.fields[keys2[j]] = $root.google.protobuf.Value.toObject(message.fields[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this Struct to JSON.
             * @function toJSON
             * @memberof google.protobuf.Struct
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Struct.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Struct;
        })();

        protobuf.Value = (function() {

            /**
             * Properties of a Value.
             * @memberof google.protobuf
             * @interface IValue
             * @property {google.protobuf.NullValue|null} [nullValue] Value nullValue
             * @property {number|null} [numberValue] Value numberValue
             * @property {string|null} [stringValue] Value stringValue
             * @property {boolean|null} [boolValue] Value boolValue
             * @property {google.protobuf.IStruct|null} [structValue] Value structValue
             * @property {google.protobuf.IListValue|null} [listValue] Value listValue
             */

            /**
             * Constructs a new Value.
             * @memberof google.protobuf
             * @classdesc Represents a Value.
             * @implements IValue
             * @constructor
             * @param {google.protobuf.IValue=} [properties] Properties to set
             */
            function Value(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Value nullValue.
             * @member {google.protobuf.NullValue|null|undefined} nullValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.nullValue = null;

            /**
             * Value numberValue.
             * @member {number|null|undefined} numberValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.numberValue = null;

            /**
             * Value stringValue.
             * @member {string|null|undefined} stringValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.stringValue = null;

            /**
             * Value boolValue.
             * @member {boolean|null|undefined} boolValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.boolValue = null;

            /**
             * Value structValue.
             * @member {google.protobuf.IStruct|null|undefined} structValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.structValue = null;

            /**
             * Value listValue.
             * @member {google.protobuf.IListValue|null|undefined} listValue
             * @memberof google.protobuf.Value
             * @instance
             */
            Value.prototype.listValue = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Value kind.
             * @member {"nullValue"|"numberValue"|"stringValue"|"boolValue"|"structValue"|"listValue"|undefined} kind
             * @memberof google.protobuf.Value
             * @instance
             */
            Object.defineProperty(Value.prototype, "kind", {
                get: $util.oneOfGetter($oneOfFields = ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue=} [properties] Properties to set
             * @returns {google.protobuf.Value} Value instance
             */
            Value.create = function create(properties) {
                return new Value(properties);
            };

            /**
             * Encodes the specified Value message. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue} message Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.nullValue != null && Object.hasOwnProperty.call(message, "nullValue"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.nullValue);
                if (message.numberValue != null && Object.hasOwnProperty.call(message, "numberValue"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.numberValue);
                if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.stringValue);
                if (message.boolValue != null && Object.hasOwnProperty.call(message, "boolValue"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.boolValue);
                if (message.structValue != null && Object.hasOwnProperty.call(message, "structValue"))
                    $root.google.protobuf.Struct.encode(message.structValue, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.listValue != null && Object.hasOwnProperty.call(message, "listValue"))
                    $root.google.protobuf.ListValue.encode(message.listValue, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Value message, length delimited. Does not implicitly {@link google.protobuf.Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.IValue} message Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Value} Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Value();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.nullValue = reader.int32();
                        break;
                    case 2:
                        message.numberValue = reader.double();
                        break;
                    case 3:
                        message.stringValue = reader.string();
                        break;
                    case 4:
                        message.boolValue = reader.bool();
                        break;
                    case 5:
                        message.structValue = $root.google.protobuf.Struct.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.listValue = $root.google.protobuf.ListValue.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Value} Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Value message.
             * @function verify
             * @memberof google.protobuf.Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    properties.kind = 1;
                    switch (message.nullValue) {
                    default:
                        return "nullValue: enum value expected";
                    case 0:
                        break;
                    }
                }
                if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.numberValue !== "number")
                        return "numberValue: number expected";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (!$util.isString(message.stringValue))
                        return "stringValue: string expected";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    if (typeof message.boolValue !== "boolean")
                        return "boolValue: boolean expected";
                }
                if (message.structValue != null && message.hasOwnProperty("structValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        let error = $root.google.protobuf.Struct.verify(message.structValue);
                        if (error)
                            return "structValue." + error;
                    }
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    if (properties.kind === 1)
                        return "kind: multiple values";
                    properties.kind = 1;
                    {
                        let error = $root.google.protobuf.ListValue.verify(message.listValue);
                        if (error)
                            return "listValue." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Value} Value
             */
            Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Value)
                    return object;
                let message = new $root.google.protobuf.Value();
                switch (object.nullValue) {
                case "NULL_VALUE":
                case 0:
                    message.nullValue = 0;
                    break;
                }
                if (object.numberValue != null)
                    message.numberValue = Number(object.numberValue);
                if (object.stringValue != null)
                    message.stringValue = String(object.stringValue);
                if (object.boolValue != null)
                    message.boolValue = Boolean(object.boolValue);
                if (object.structValue != null) {
                    if (typeof object.structValue !== "object")
                        throw TypeError(".google.protobuf.Value.structValue: object expected");
                    message.structValue = $root.google.protobuf.Struct.fromObject(object.structValue);
                }
                if (object.listValue != null) {
                    if (typeof object.listValue !== "object")
                        throw TypeError(".google.protobuf.Value.listValue: object expected");
                    message.listValue = $root.google.protobuf.ListValue.fromObject(object.listValue);
                }
                return message;
            };

            /**
             * Creates a plain object from a Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Value
             * @static
             * @param {google.protobuf.Value} message Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
                    object.nullValue = options.enums === String ? $root.google.protobuf.NullValue[message.nullValue] : message.nullValue;
                    if (options.oneofs)
                        object.kind = "nullValue";
                }
                if (message.numberValue != null && message.hasOwnProperty("numberValue")) {
                    object.numberValue = options.json && !isFinite(message.numberValue) ? String(message.numberValue) : message.numberValue;
                    if (options.oneofs)
                        object.kind = "numberValue";
                }
                if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                    object.stringValue = message.stringValue;
                    if (options.oneofs)
                        object.kind = "stringValue";
                }
                if (message.boolValue != null && message.hasOwnProperty("boolValue")) {
                    object.boolValue = message.boolValue;
                    if (options.oneofs)
                        object.kind = "boolValue";
                }
                if (message.structValue != null && message.hasOwnProperty("structValue")) {
                    object.structValue = $root.google.protobuf.Struct.toObject(message.structValue, options);
                    if (options.oneofs)
                        object.kind = "structValue";
                }
                if (message.listValue != null && message.hasOwnProperty("listValue")) {
                    object.listValue = $root.google.protobuf.ListValue.toObject(message.listValue, options);
                    if (options.oneofs)
                        object.kind = "listValue";
                }
                return object;
            };

            /**
             * Converts this Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Value;
        })();

        /**
         * NullValue enum.
         * @name google.protobuf.NullValue
         * @enum {number}
         * @property {number} NULL_VALUE=0 NULL_VALUE value
         */
        protobuf.NullValue = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "NULL_VALUE"] = 0;
            return values;
        })();

        protobuf.ListValue = (function() {

            /**
             * Properties of a ListValue.
             * @memberof google.protobuf
             * @interface IListValue
             * @property {Array.<google.protobuf.IValue>|null} [values] ListValue values
             */

            /**
             * Constructs a new ListValue.
             * @memberof google.protobuf
             * @classdesc Represents a ListValue.
             * @implements IListValue
             * @constructor
             * @param {google.protobuf.IListValue=} [properties] Properties to set
             */
            function ListValue(properties) {
                this.values = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ListValue values.
             * @member {Array.<google.protobuf.IValue>} values
             * @memberof google.protobuf.ListValue
             * @instance
             */
            ListValue.prototype.values = $util.emptyArray;

            /**
             * Creates a new ListValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue=} [properties] Properties to set
             * @returns {google.protobuf.ListValue} ListValue instance
             */
            ListValue.create = function create(properties) {
                return new ListValue(properties);
            };

            /**
             * Encodes the specified ListValue message. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.values != null && message.values.length)
                    for (let i = 0; i < message.values.length; ++i)
                        $root.google.protobuf.Value.encode(message.values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ListValue message, length delimited. Does not implicitly {@link google.protobuf.ListValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.IListValue} message ListValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ListValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ListValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ListValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.ListValue} ListValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ListValue();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.values && message.values.length))
                            message.values = [];
                        message.values.push($root.google.protobuf.Value.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ListValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.ListValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.ListValue} ListValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ListValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ListValue message.
             * @function verify
             * @memberof google.protobuf.ListValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ListValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.values != null && message.hasOwnProperty("values")) {
                    if (!Array.isArray(message.values))
                        return "values: array expected";
                    for (let i = 0; i < message.values.length; ++i) {
                        let error = $root.google.protobuf.Value.verify(message.values[i]);
                        if (error)
                            return "values." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ListValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.ListValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.ListValue} ListValue
             */
            ListValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ListValue)
                    return object;
                let message = new $root.google.protobuf.ListValue();
                if (object.values) {
                    if (!Array.isArray(object.values))
                        throw TypeError(".google.protobuf.ListValue.values: array expected");
                    message.values = [];
                    for (let i = 0; i < object.values.length; ++i) {
                        if (typeof object.values[i] !== "object")
                            throw TypeError(".google.protobuf.ListValue.values: object expected");
                        message.values[i] = $root.google.protobuf.Value.fromObject(object.values[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ListValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.ListValue
             * @static
             * @param {google.protobuf.ListValue} message ListValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ListValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.values = [];
                if (message.values && message.values.length) {
                    object.values = [];
                    for (let j = 0; j < message.values.length; ++j)
                        object.values[j] = $root.google.protobuf.Value.toObject(message.values[j], options);
                }
                return object;
            };

            /**
             * Converts this ListValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.ListValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ListValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ListValue;
        })();

        return protobuf;
    })();

    return google;
})();

export const StoneCode = $root.StoneCode = (() => {

    /**
     * Namespace StoneCode.
     * @exports StoneCode
     * @namespace
     */
    const StoneCode = {};

    StoneCode.PlatformBundle = (function() {

        /**
         * Namespace PlatformBundle.
         * @memberof StoneCode
         * @namespace
         */
        const PlatformBundle = {};

        PlatformBundle.Common = (function() {

            /**
             * Namespace Common.
             * @memberof StoneCode.PlatformBundle
             * @namespace
             */
            const Common = {};

            Common.Entity = (function() {

                /**
                 * Namespace Entity.
                 * @memberof StoneCode.PlatformBundle.Common
                 * @namespace
                 */
                const Entity = {};

                Entity.Urn = (function() {

                    /**
                     * Properties of an Urn.
                     * @memberof StoneCode.PlatformBundle.Common.Entity
                     * @interface IUrn
                     * @property {string|null} [partition] Urn partition
                     * @property {string|null} [service] Urn service
                     * @property {string|null} [resource] Urn resource
                     * @property {string|null} [identifier] Urn identifier
                     */

                    /**
                     * Constructs a new Urn.
                     * @memberof StoneCode.PlatformBundle.Common.Entity
                     * @classdesc Represents an Urn.
                     * @implements IUrn
                     * @constructor
                     * @param {StoneCode.PlatformBundle.Common.Entity.IUrn=} [properties] Properties to set
                     */
                    function Urn(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Urn partition.
                     * @member {string} partition
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @instance
                     */
                    Urn.prototype.partition = "";

                    /**
                     * Urn service.
                     * @member {string} service
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @instance
                     */
                    Urn.prototype.service = "";

                    /**
                     * Urn resource.
                     * @member {string} resource
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @instance
                     */
                    Urn.prototype.resource = "";

                    /**
                     * Urn identifier.
                     * @member {string} identifier
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @instance
                     */
                    Urn.prototype.identifier = "";

                    /**
                     * Creates a new Urn instance using the specified properties.
                     * @function create
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {StoneCode.PlatformBundle.Common.Entity.IUrn=} [properties] Properties to set
                     * @returns {StoneCode.PlatformBundle.Common.Entity.Urn} Urn instance
                     */
                    Urn.create = function create(properties) {
                        return new Urn(properties);
                    };

                    /**
                     * Encodes the specified Urn message. Does not implicitly {@link StoneCode.PlatformBundle.Common.Entity.Urn.verify|verify} messages.
                     * @function encode
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {StoneCode.PlatformBundle.Common.Entity.IUrn} message Urn message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Urn.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.partition != null && Object.hasOwnProperty.call(message, "partition"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.partition);
                        if (message.service != null && Object.hasOwnProperty.call(message, "service"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.service);
                        if (message.resource != null && Object.hasOwnProperty.call(message, "resource"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.resource);
                        if (message.identifier != null && Object.hasOwnProperty.call(message, "identifier"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.identifier);
                        return writer;
                    };

                    /**
                     * Encodes the specified Urn message, length delimited. Does not implicitly {@link StoneCode.PlatformBundle.Common.Entity.Urn.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {StoneCode.PlatformBundle.Common.Entity.IUrn} message Urn message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Urn.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Urn message from the specified reader or buffer.
                     * @function decode
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {StoneCode.PlatformBundle.Common.Entity.Urn} Urn
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Urn.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StoneCode.PlatformBundle.Common.Entity.Urn();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.partition = reader.string();
                                break;
                            case 2:
                                message.service = reader.string();
                                break;
                            case 3:
                                message.resource = reader.string();
                                break;
                            case 4:
                                message.identifier = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Urn message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {StoneCode.PlatformBundle.Common.Entity.Urn} Urn
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Urn.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Urn message.
                     * @function verify
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Urn.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.partition != null && message.hasOwnProperty("partition"))
                            if (!$util.isString(message.partition))
                                return "partition: string expected";
                        if (message.service != null && message.hasOwnProperty("service"))
                            if (!$util.isString(message.service))
                                return "service: string expected";
                        if (message.resource != null && message.hasOwnProperty("resource"))
                            if (!$util.isString(message.resource))
                                return "resource: string expected";
                        if (message.identifier != null && message.hasOwnProperty("identifier"))
                            if (!$util.isString(message.identifier))
                                return "identifier: string expected";
                        return null;
                    };

                    /**
                     * Creates an Urn message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {StoneCode.PlatformBundle.Common.Entity.Urn} Urn
                     */
                    Urn.fromObject = function fromObject(object) {
                        if (object instanceof $root.StoneCode.PlatformBundle.Common.Entity.Urn)
                            return object;
                        let message = new $root.StoneCode.PlatformBundle.Common.Entity.Urn();
                        if (object.partition != null)
                            message.partition = String(object.partition);
                        if (object.service != null)
                            message.service = String(object.service);
                        if (object.resource != null)
                            message.resource = String(object.resource);
                        if (object.identifier != null)
                            message.identifier = String(object.identifier);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Urn message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @static
                     * @param {StoneCode.PlatformBundle.Common.Entity.Urn} message Urn
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Urn.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.partition = "";
                            object.service = "";
                            object.resource = "";
                            object.identifier = "";
                        }
                        if (message.partition != null && message.hasOwnProperty("partition"))
                            object.partition = message.partition;
                        if (message.service != null && message.hasOwnProperty("service"))
                            object.service = message.service;
                        if (message.resource != null && message.hasOwnProperty("resource"))
                            object.resource = message.resource;
                        if (message.identifier != null && message.hasOwnProperty("identifier"))
                            object.identifier = message.identifier;
                        return object;
                    };

                    /**
                     * Converts this Urn to JSON.
                     * @function toJSON
                     * @memberof StoneCode.PlatformBundle.Common.Entity.Urn
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Urn.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Urn;
                })();

                return Entity;
            })();

            return Common;
        })();

        return PlatformBundle;
    })();

    return StoneCode;
})();

export { $root as default };
